export default {
  layout: 'main-sidebar-layout',
  auth: true,
  organizer: true,
  slug: 'organizer'
}
